import { isValid, parse } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';
import { type AB_TESTS, AB_TESTS_START_DATE, DATE_FORMAT } from '../constants';

const parseDate = (dateStr: string) =>
  fromZonedTime(parse(dateStr, DATE_FORMAT, new Date(0)), 'UTC');

export const isUserAppropriateForTest = (
  name: string,
  createdAt?: string | null
): boolean => {
  const matchingTest = (Object.keys(AB_TESTS_START_DATE) as AB_TESTS[]).find(
    (test) => name.startsWith(test)
  );
  const startDate = matchingTest
    ? AB_TESTS_START_DATE[matchingTest]
    : undefined;
  if (!startDate) return true;

  if (!createdAt) return false;
  const userRegDate = parseDate(createdAt);
  const testStartDate = parseDate(startDate);
  if (!(isValid(userRegDate) && isValid(testStartDate))) return false;

  return userRegDate > testStartDate;
};
